module.exports = __webpack_public_path__ + "img/arrow-right-white.8ece0802.svg";